import React, { Component } from 'react';
import {
  Header,
  Message,
  List,
  Segment,
  Table
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import CvssDisplay from '../Security/CvssDisplay';

class CveDetail extends Component {
  componentDidMount() {
  }

  renderReference = (source, desc, url, tags) => {
    const { translate } = this.props;
    const refDatas = Object.assign(source.map((k, i) => {
      return {
        key: k || null,
        url: url ? url[i] : null,
        tag: tags ? tags[i] : null,
      };
    }));

    return (
      <Table
        className="reference"
        celled
        padded
        fixed
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={2}>{translate('modal.title.source')}</Table.HeaderCell>
            <Table.HeaderCell width={3}>{translate('modal.title.tag')}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            refDatas.map((item) => {
              return (
                <Table.Row key={[item.ref || null].join('')}>
                  <Table.Cell
                    title={[item.key || null].join('')}
                    verticalAlign="middle"
                  >
                    {item.key || null}
                  </Table.Cell>
                  <Table.Cell
                    title={[item.tag || null].join('')}
                    verticalAlign="top"
                  >
                    {item.tag ? item.tag.map((nest, idx) => {
                      if (idx === 0) {
                        return (
                          <div key={nest}>
                            {nest}
                            <br />
                          </div>
                        );
                      }
                      return (
                        <div key={nest} style={{ marginTop: '1px' }}>
                          {nest}
                          <br />
                        </div>
                      );
                    }) : null}
                  </Table.Cell>
                </Table.Row>
              );
            })
          }
        </Table.Body>
      </Table>
    );
  };

  renderVulnPkg = (array) => {
    let nextCIndex;
    let nextWIndex;
    let wIndex;
    let isStartTab = false;
    const cIndexTotal = [];
    const wIndexTotal = [];

    if (!array) {
      return;
    }
    array.findIndex((o, index) => {
      if (o.indexOf('Configuration') > -1) {
        cIndexTotal.push(index);
      }
      if (o.indexOf('With') > -1) {
        wIndexTotal.push(index);
      }
      return null;
    });

    const result = array.map(
      (vuln, idx) => {
        if (wIndexTotal.length !== 0 && wIndexTotal.indexOf(idx) > -1) {
          isStartTab = true;
        }

        if (cIndexTotal.length !== 0 && cIndexTotal.indexOf(idx) > -1) {
          isStartTab = false;
        }

        if (vuln.indexOf('Configuration') > -1) {
          const currentIndex = cIndexTotal.findIndex((o) => {
            return o === idx;
          });
          nextCIndex = cIndexTotal[currentIndex + 1];

          return (
            <tr key={uuidv4()}>
              <td
                style={{
                  fontSize: '13px',
                  wordBreak: 'break-all',
                  padding: '5px 0 5px 0',
                  border: 0,
                  fontWeight: 'bold',
                  background: '#f7f7f7',
                }}
              >
                {vuln}
              </td>
            </tr>
          );
        }

        if (vuln.indexOf('With') > -1) {
          wIndex = idx;
          const currentIndex = wIndexTotal.findIndex((o) => {
            return o === idx;
          });
          nextWIndex = wIndexTotal[currentIndex + 1];
          return (
            <tr key={uuidv4()}>
              <td
                style={{
                  fontSize: '13px',
                  wordBreak: 'break-all',
                  padding: '5px 0 5px 10px',
                  border: 0,
                  fontWeight: 'bold'
                }}
              >
                {vuln}
              </td>
            </tr>
          );
        }

        if (wIndex && nextWIndex && nextCIndex && wIndex < idx < nextWIndex && idx < nextCIndex && isStartTab) {
          return (
            <tr key={uuidv4()}>
              <td
                style={{
                  fontSize: '13px',
                  wordBreak: 'break-all',
                  padding: '5px 0 5px 20px',
                  border: 0,
                }}
              >
                {vuln}
              </td>
            </tr>
          );
        }

        return (
          <tr key={uuidv4()}>
            <td
              style={{
                fontSize: '13px',
                wordBreak: 'break-all',
                padding: '5px 0 5px 10px',
                border: 0,
              }}
            >
              {vuln}
            </td>
          </tr>
        );
      }
    );
    return result;
  };

  render() {
    const {
      rowData,
      translate
    } = this.props;

    //const { translate } = this.props;

    return (
      <Segment.Group>
        <Segment>
          <Header as="h3">
            {rowData.security_name}
            &nbsp;
            Detail
          </Header>
        </Segment>
        <Segment>
          {
            rowData.more_info
          && (
            <div className="content_wrap">
              <div className="content">
                <Message header={translate('list.title.description')} content={rowData.more_info.description} />
              </div>
              <CvssDisplay
                securityInfo={rowData.more_info}
                translate={translate}
              />
              {
                rowData.more_info.rejected
                && (
                  <div className="content">
                    <p className="label">{translate('modal.cve.rejected')}</p>
                    <div className="value" style={{ color: '#912d2b' }}>{rowData.more_info.rejected}</div>
                  </div>
                )
              }
              {
                rowData.more_info.type !== ''
                && (
                  <div className="content">
                    <p className="label">{translate('modal.cve.common_weakness_enumeration')}</p>
                    <div className="value">{rowData.more_info.type}</div>
                  </div>
                )
              }
              <div className="content">
                <p className="label">{translate('modal.cve.published_date')}</p>
                <div className="value">{rowData.more_info.pdate}</div>
              </div>
              <div className="content">
                <p className="label">{translate('modal.cve.last_modified_date')}</p>
                <div className="value">{rowData.more_info.mdate}</div>
              </div>
              {
                rowData.more_info.refsource.length !== 0 ? (
                  <div className="content">
                    <p className="label">{translate('modal.cve.references')}</p>
                    {this.renderReference(rowData.more_info.refsource, rowData.more_info.refdescription, rowData.more_info.web_site, rowData.more_info.reftags)}
                  </div>
                ) : null
              }
              {rowData.more_info.patch_url.length !== 0 ? (
                <div className="content">
                  <p className="label">{translate('modal.cve.pathc_url')}</p>
                  <List>
                    {rowData.more_info.patch_url.map((url) => {
                      return (
                        <List.Item className="patch_url" key={url.toString()}>
                          <List.Content style={{ fontSize: '14px', marginTop: '10px', paddingLeft: '10px' }}>
                            <a href={url} target="_blank" rel="noopener noreferrer">
                              {url}
                            </a>
                          </List.Content>
                        </List.Item>
                      );
                    })}
                  </List>
                </div>
              ) : null}
              {
                (rowData.more_info.vuln_sw.length !== 0 && !(rowData.more_info.vuln_sw.length === 1 && rowData.more_info.vuln_sw[0] === ''))
                && (
                  <div className="content">
                    <p className="label">{translate('modal.cve.vulnerable_packages')}</p>
                  </div>
                )
              }
              {(rowData.more_info.vuln_sw.length !== 0 && !(rowData.more_info.vuln_sw.length === 1 && rowData.more_info.vuln_sw[0] === '')) && (
                <div className="popup_content_wrap">
                  <table
                    className="table"
                    style={{ marginBottom: '30px', tableLayout: 'fixed' }}
                  >
                    <tbody>
                      {this.renderVulnPkg(rowData.more_info.vuln_sw)}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )
          }
        </Segment>
      </Segment.Group>
    );
  }
}
export default CveDetail;
